<template>
  <div class="homepage">

    <!-- 第一部分：顶部大图 -->
    <section class="hero-section">
      <img src="@/assets/about/hero.png" alt="展示图" class="hero-image" />
    </section>

    <!-- 第二部分：标题 + 左文右图 -->
    <section class="section-two content-wrapper">
      <h2 class="center-title">公司介绍</h2>
      <div class="text-image-row">
        <div class="text-block">
          <h2 class="section-title">定位使命</h2>
          <p>武汉原牧欣网络科技有限公司，致力于为企业和创新者提供高效、可靠的技术解决方案。我们以技术开发为核心，助力客户实现数字化转型、产品创新与业务增长</p>
        </div>
        <div class="image-block">
          <img src="@/assets/about/first-right-show.png" alt="使命" />
        </div>
      </div>
    </section>

    <!-- 第三部分：整屏图片展示 -->
    <section class="full-image-section">
      <img src="@/assets/about/core-power.png" alt="展示图" />
    </section>

    <!-- 第四部分：标题靠左 + 3列图片 -->
    <section class="three-image-section content-wrapper">
      <h2 class="left-title">我们的优势</h2>
      <div class="image-grid">
        <img v-for="(img, index) in imageList" :key="index" :src="img" alt="能力展示" />
      </div>
    </section>

    <!-- 第五部分：整屏图片展示 -->
    <section class="full-image-section">
      <img src="@/assets/about/service-area.png" alt="展示图" />
    </section>

    <!-- 第六部分：左文右图 -->
    <section class="section-six content-wrapper">
      <div class="text-image-row">
        <div class="text-block">
          <h2 class="section-title">合作理念</h2>
          <p>“以代码构建信任，用技术兑现承诺”——我们追求长期伙伴关系，为每一次合作负责到底。</p>
        </div>
        <div class="image-block">
          <img src="@/assets/about/second-right-show.png" alt="未来" />
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      imageList: [
        require('@/assets/about/team.png'),
        require('@/assets/about/creative.png'),
        require('@/assets/about/customer.png')
      ]
    }
  }
}
</script>

<style scoped>
.homepage {
  font-family: sans-serif;
}

/* 顶部大图 */
.hero-section img {
  width: 100%;
  height: auto;
  display: block;
}

/* 内容容器 */
.content-wrapper {
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 0;
}

/* 第二部分 */
.section-two {
  padding: 2.5rem 0;
}

.center-title {
  text-align: center;
  color: black;
  font-size: clamp(28px, 5vw, 35px);
  font-weight: bold;
  margin-bottom: 1.5rem;
}





/* 左文右图行 */
.text-image-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  align-items: center;
  justify-content: center;
}

.text-block {
  flex: 1 1 280px;
  min-width: 280px;
}

.text-block h3 {
  font-size: clamp(22px, 4vw, 35px);
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.text-block p {
  font-size: clamp(16px, 2.5vw, 20px);
  color: #555;
  line-height: 1.6;
}

.image-block {
  flex: 1 1 280px;
  min-width: 280px;
}

.image-block img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  display: block;
}

/* 整屏图片 */
.full-image-section {
  margin: 2.5rem 0;
}

.full-image-section img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 10px;
}

/* 第四部分 */
.three-image-section {
  padding: 2.5rem 0;
}

.left-title {
  text-align: left;
  color: black;
  font-size: clamp(28px, 5vw, 35px);
  font-weight: bold;
  margin-bottom: 1.5rem;
  margin-bottom: 1rem;
  margin-left: 2rem;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

.image-grid img {
  width: 100%;
  border-radius: 10px;
  display: block;
}

/* 第六部分 */
.section-six {
  padding: 2.5rem 0;
}

/* 指定右图保持原图尺寸 */
.image-block img[src*="first-right-show"],
.image-block img[src*="second-right-show"] {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
}

.section-title {
  color: black;
  font-size: clamp(28px, 5vw, 35px);
  font-weight: bold;
  margin-bottom: 1.5rem;
}

/* 响应式 */

/* 中屏，tablet */
@media (max-width: 992px) {
  .image-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 小屏，mobile */
@media (max-width: 600px) {
  .content-wrapper {
    width: 95vw;
    padding: 0.5rem 0;
  }

  .text-image-row {
    flex-direction: column;
    gap: 1.5rem;
  }

  .left-title {
    margin-left: 0;
  }

  .image-grid {
    grid-template-columns: 1fr;
  }
}
</style>
